import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {InlineUserDashboardSection} from "../components/InlineUserDashboardSection";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {InlineUserDashboardTab} from "./InlineUserDashboardTab";
import {CardItem} from "../../../../common/CardItem";
import {InlineUserDashboardPaymentsTable} from "../components/InlineUserDashboardPaymentsTable";
import {PaymentStore} from "../../../../../client/state/PaymentStore";
import {paymentMethodController} from "../../../inline-donation/PaymentMethodController";
import {CARD_SECTION_STATE} from "../../../inline-donation/PaymentMethodController";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {subscribeFlowState} from "../../../inline-subscription/SubscribeFlowState";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_EDIT_SUBSCRIPTION_URLS, INLINE_USER_DASHBOARD_URLS} from "../../../PaywallConstants";
import {addressController} from "../../../inline-subscription/AddressController";
import {ADDRESS_SECTION_STATE} from "../../panels/address/AddressPanel";
import {inlineUserDashboardState} from "../InlineUserDashboardState";
import {SUBSCRIBE_PLAN_STATE, subscribePlanController} from "../../../inline-subscription/SubscribePlanController";
import {SubscriptionApplyPolicy, SubscriptionStore} from "../../../../../client/state/SubscriptionStore";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {UsingBlinkDefaultPaymentMethod} from "../../../../common/UsingBlinkDefaultPaymentMethod";
import {fetchSubscriptionPrices} from "../../../inline-subscription/SubscribeFlowState";
import {PANEL_TYPE, TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {updateSubscription} from "../prompt-panels/InlineUserDashboardSubscriptionChangeConfirmPanel";
import {SocialAccountProvider, SocialAccountStore} from "../../../../../client/state/SocialAccountStore";
import {InlineUserDashboardCDSAccountSection} from "../components/InlineUserDashboardCDSSection";
import {startSubscriptionFlow} from "../../../flows/startFlow";


function CDSSubscriptionAccountSection(subscription, styleSheet) {
    const cdsSocialAccount = SocialAccountStore.find(socialAccount => socialAccount.provider === SocialAccountProvider.CDS && socialAccount.extraData?.handlesSubscriptions);
    return InlineUserDashboardCDSAccountSection(cdsSocialAccount, styleSheet);
}


@autoredraw(PaymentMethodStore, UserAddressStore, SubscriptionStore)
export class InlineUserDashboardSubscriptionTab extends InlineUserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.inlineUserDashboardSubscription,
        }
    }

    editPlan() {
        const subscription = iFrameUserDataService.getActiveSubscription();

        const onSelectSuccess = async () => {
            await fetchSubscriptionPrices();
            Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm);
        }

        addressController.update({
            addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
            selectedAddress: subscription.getShippingAddress(),
            onSelectCancel: () => Router.back(),
            onSelectSuccess,
            continueLabel: Messages.continue,
        });
        subscribePlanController.update({
            subscribePlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
            selectedOffer: subscription.getOffer(),
            onSelectSuccess: async () => {
                if (subscribePlanController.selectedOffer) {
                    await fetchSubscriptionPrices();
                    Router.changeURL(INLINE_USER_DASHBOARD_URLS.editSubscriptionAddress);
                    return;
                }
                await onSelectSuccess();
            },
            onSelectCancel: () => Router.back(),
            applyPolicy: SubscriptionApplyPolicy.NEXT_BILLING_CYCLE,
            discountCode: subscription.getDiscount()?.getCode() || null,
        });
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.editSubscriptionPlan);
    }

    editAddress() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        const onSelectSuccess = async () => {
            await fetchSubscriptionPrices();
            const finalPrice = subscription.getOffer().formatPrice(subscribeFlowState.getDiscountInfo(subscription.getOffer())?.finalPrice);
            Router.back();
            inlineUserDashboardState.addressChangeInitialPrice = subscription.getPrice();
            inlineUserDashboardState.addressChangeFinalPrice = finalPrice;
            Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm)
        };
        addressController.update({
            addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
            selectedAddress: subscription.getShippingAddress(),
            onSelectCancel: () => Router.back(),
            onSelectSuccess,
            continueLabel: Messages.continue,
        });
        subscribePlanController.update({
            subscribePlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
            selectedOffer: subscription.getOffer(),
            applyPolicy: SubscriptionApplyPolicy.INSTANTLY,
            discountCode: subscription.getDiscount()?.getCode() || null,
        });
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.editSubscriptionAddress);
    }

    editPaymentMethod() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        paymentMethodController.update({
            showSaveCardCheckbox: true,
            cardSectionState: CARD_SECTION_STATE.chooseCard,
            entry: subscription,
            initialPaymentMethod: subscription.getPaymentMethod(),
            selectedPaymentMethod: subscription.getPaymentMethod(),
            savePaymentMethod: true,
            getChooseCardButtonLabel: () => Messages.updatePaymentMethod,
            getPayWithAddedCardButtonLabel: () => Messages.updatePaymentMethod,
            getScope: () => PaymentMethodStore.Scope.RECURRING_PAYMENT,
            onSelectSuccess: () => updateSubscription({
                preferredPaymentMethodId:
                    subscription.getPaymentMethod() === paymentMethodController.selectedPaymentMethod ?
                        null : paymentMethodController.selectedPaymentMethod.id,
            }),
        });
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.editSubscriptionPaymentMethod);
    }

    cancelSubscription() {
        subscribePlanController.update({
            subscribePlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
            selectedOffer: iFrameUserDataService.getActiveSubscription().getOffer(),
            onSelectCancel: () => Router.back(),
            onCancel: () => Router.changeURL(PANEL_TYPE.dashboard),
        })
        Router.changeURL(INLINE_EDIT_SUBSCRIPTION_URLS.cancel);
    }

    renderSubscription() {
        const {styleSheet} = this;
        const subscription = iFrameUserDataService.getActiveSubscription();

        if (!subscription) {
            return [
                <InlineUserDashboardSection titleMessage={Messages.subscriptionPlanTitle}>
                    <MessageElement className={styleSheet.textSection}
                                    message={Messages.notSubscribedToMerchant}
                                    args={[iFrameMerchantService.getMerchant().name]} />
                    <MerchantButton label={Messages.subscribe} className={styleSheet.button}
                                    onClick={() => startSubscriptionFlow()}/>
                </InlineUserDashboardSection>,
            ];
        }

        const preferredPaymentMethod = subscription.getPaymentMethod();
        const planActions = iFrameMerchantService.isCDSPaymentMethod() ? {} : {
            actionMessage: Messages.change,
            actionFunction: () => this.editPlan(),
        };
        const paymentMethodActions = iFrameMerchantService.isCDSPaymentMethod() ? {} : {
            actionMessage: Messages.edit,
            actionFunction: () => this.editPaymentMethod(),
        };

        return [
            <InlineUserDashboardSection titleMessage={Messages.subscriptionPlanTitle} {...planActions}>
                <MessageElement className={styleSheet.textSection} message={Messages.subscribedCurrentPlan}
                                args={[subscription.getOffer().getName(), subscription.formatPrice()]} />
                {iFrameMerchantService.isMerchant(TNR_ALIAS) &&
                    <MessageElement className={styleSheet.textSection} message={Messages.tnrDashboardPlanMessage}/>}
            </InlineUserDashboardSection>,
            subscription.getShippingAddress() &&
                <InlineUserDashboardSection titleMessage={Messages.inlineAddressSectionTitle} actionMessage={Messages.edit}
                                            actionFunction={() => this.editAddress()}>
                    <div>{subscription.getShippingAddress().getRecipientName()}</div>
                    <div>{subscription.getShippingAddress()}</div>
                </InlineUserDashboardSection>,
            <InlineUserDashboardSection titleMessage={Messages.paymentMethodTitle} {...paymentMethodActions}>
                {
                    preferredPaymentMethod ?
                        <CardItem card={subscription.getPaymentMethod()} showExpiryDate={false}/> : (
                            iFrameUserDataService.hasPrimaryPaymentMethod() && !iFrameMerchantService.isCDSPaymentMethod()?
                                <UsingBlinkDefaultPaymentMethod/> :
                                <div className={styleSheet.cardDetails}>
                                    <div>{Messages.noPaymentMethodForThisSubscription}</div>
                                </div>
                        )
                }
                <MessageElement className={styleSheet.textSection}
                                message={Messages.paymentMethodCharge(subscription.getPrice(), subscription.getCycleDuration())}/>
            </InlineUserDashboardSection>,
            CDSSubscriptionAccountSection(subscription, this.styleSheet),
        ];
    }

    renderPaymentHistory() {
        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            return null;
        }
        return <InlineUserDashboardSection titleMessage={Messages.paymentHistory}>
            <InlineUserDashboardPaymentsTable resourceType={PaymentStore.ResourceType.SUBSCRIPTION}/>
        </InlineUserDashboardSection>;
    }

    render() {
        return [
            this.renderSubscription(),
            this.renderPaymentHistory(),
        ];
    }
}
